import { render } from "./ProjectShowcase.vue?vue&type=template&id=1af39587"
import script from "./ProjectShowcase.vue?vue&type=script&lang=js"
export * from "./ProjectShowcase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__